// extracted by mini-css-extract-plugin
export default {"root":"tw-factor_root__jjOss","link":"tw-factor_link__BJ6nN"};